import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import { formatNumber } from '@/frontend/pages/CommandCenter/Telemetry/utils'
import type { TokenBreakdown } from '@/frontend/pages/CommandCenter/Telemetry/types'

interface Props {
  total: number | null
  breakdown?: TokenBreakdown | null
}

export default function TokensWithBreakdown({ total, breakdown }: Props) {
  if (total == null) return null

  const formatted = formatNumber(total)
  const hasBreakdown = breakdown &&
    (breakdown.input > 0 || breakdown.output > 0 || breakdown.cacheRead > 0 || breakdown.cacheWrite > 0)

  if (!hasBreakdown) return <>{formatted}</>

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="border-b border-dotted border-border cursor-help">
          {formatted}
        </span>
      </TooltipTrigger>
      <TooltipContent className="text-left">
        <div className="space-y-0.5">
          {breakdown.input > 0 && <div>Entrada: {formatNumber(breakdown.input)}</div>}
          {breakdown.output > 0 && <div>Saída: {formatNumber(breakdown.output)}</div>}
          {breakdown.cacheRead > 0 && <div>Cache lido: {formatNumber(breakdown.cacheRead)}</div>}
          {breakdown.cacheWrite > 0 && <div>Cache escrito: {formatNumber(breakdown.cacheWrite)}</div>}
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
